import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { QueriesClientService } from "@rightship-tech/common-ui/services/queries/queries-client.services";
import { autoinject } from "aurelia-framework";
import Enumerable from "linq";

@autoinject
export class AuditsApi {

    public platformUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}`

    constructor(private queriesClientService: QueriesClientService, private configService: ConfigService) { }

    public async getDocumentAudits(ids: number[], documentTypeId: number): Promise<any> {
        const promises: Promise<any>[] = [];
        ids.forEach(id => {
            promises.push(this.queriesClientService.getData(`${this.platformUrl}/odata/RightShipAudits/GetAudits(entityTypeId=${documentTypeId},entityId=${id})?$orderby=timestamp desc`));
        });
        const results = await Promise.all(promises);

        const audits = Enumerable.from(results).selectMany(x => x.value).distinct((x:any) => `${x.action}_${x.timestamp}_${x.userName}`).toArray();

        return audits;
    }
}
